/**
 * Chain configuration for multi-chain support.
 *
 * The Prisma schema defines all possible Chain enum values (WAX, POAP, EOS, etc.)
 * but only a subset are currently enabled in the UI.
 */

export interface ChainOption {
  value: string;
  label: string;
  description: string;
  requiresWallet: boolean;
  logo: string;
  requiredPlan?: 'STARTER' | 'PREMIUM';
}

/**
 * Chains currently visible and selectable in the UI.
 * Other enum values exist in the schema for future use.
 */
export const VISIBLE_CHAINS: ChainOption[] = [
  {
    value: 'WAX',
    label: 'WAX',
    description: 'Mint NFTs on the WAX blockchain',
    requiresWallet: true,
    logo: '/images/chains/wax.png',
    requiredPlan: 'STARTER',
  },
  {
    value: 'POAP',
    label: 'POAP',
    description: 'Proof of Attendance Protocol',
    requiresWallet: false,
    logo: '/images/chains/poap.png',
    requiredPlan: 'PREMIUM',
  },
];

export const DEFAULT_CHAIN = 'WAX';

export function getChainOption(chain: string): ChainOption | undefined {
  return VISIBLE_CHAINS.find((c) => c.value === chain);
}

export function isVisibleChain(chain: string): boolean {
  return VISIBLE_CHAINS.some((c) => c.value === chain);
}
